export function formatDate(dateString, options = {}) {
	try {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) {
			console.warn(`Invalid date value: ${dateString}`);
			return ""; // Return an empty string or a default value
		}
		return date.toLocaleDateString("de-DE", options);
	} catch (error) {
		console.error(`Error formatting date: ${dateString}`, error);
		return ""; // Return an empty string or a default value
	}
}


